import React from "react";
import { connect } from "react-redux";
import { FormattedMessage } from "react-intl";
import cx from "classnames";

function ThinkingModal({ brand, className }) {
  const style = { backgroundColor: brand.backgroundColor };
  return (
    <div className={cx("Thinking", className)} style={style}>
      <div>
        <span className="dot" />
        <span className="dot" />
        <span className="dot" />
      </div>
      <p>
        <FormattedMessage id="modal.thinking.text" />
      </p>
    </div>
  );
}

export default connect(state => ({
  brand: state.brand.settings
}))(ThinkingModal);



// WEBPACK FOOTER //
// ./src/modules/modal/thinking-modal.js